import type { IconSvgObject } from './types';

const Lamp01Icon: IconSvgObject = [
  ["path", { d: "M9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.0002 20V22M15 19L17 20.4999M9 19L7 20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 13H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18 13C18 9.68629 15.3137 7 12 7C8.68629 7 6 9.68629 6 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 7V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Lamp01Icon;
